import React from "react";
import CompanyModalV2 from "./CompanyModalV2";

/** Company Details sidebar. */
const CompanyModal = (props) => <CompanyModalV2 {...props} />;

export default CompanyModal;
